import React, { useState } from "react";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import "./styles.less";
import { ConsultFormModal } from "../../components/CommonFormModal";
import { Link } from "../../components/LinkIcon";
import { tryNow } from "../../utils";

export const SolutionIndustryBanner = (props) => {
  const { title, subtitle, imgUrl } = props;

  const [visible, setVisible] = useState(false);

  const { t } = useTranslation();

  return (
    <div>
      <section
        className="solution-industry-banner"
        style={{ background: `url(${imgUrl})` }}
      >
        <div className="solution-industry-banner-content">
          <div className="solution-industry-banner-text">
            <h3 className="title">{title}</h3>
            <div className="subtitle">{subtitle}</div>
            <div className="solution-button-warp">
              <div
                className="solution-button"
                onClick={() => {
                  setVisible(true);
                }}
              >
                {t("solution.detail.button-consult")}
              </div>
              <div className="solution-button-link">
                <Link style={{ color: "#fff" }} onClick={tryNow}>
                  {t("common.button.try-now")}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ConsultFormModal {...{ visible, setVisible }} />
    </div>
  );
};
